﻿import SearchEntryPage from "../searchEntryPage";

export default class DataQuery extends SearchEntryPage {

    constructor() {
        super();
    }

    // Override the base SearchEntryPage behavior.
    // Do NOT auto-load the first query when the search results load. Instead show a blank
    // info page so the user explicitly selects a query or adds a new one.
    // (the no-results case is already handled by searchResultGridRequestEnd)
    searchGridSelectRow(e) {
        if (this.selectSearchResultRow) {
            if (e.sender.dataSource.total() > 0) {
                const url = $(this.searchContainer).data("empty-detail-url");
                this.showDetails(url);
            }
            return;
        }
        this.selectSearchResultRow = true;
    }

    // Track pending AQB requests so a query switch can wait for them (see loadSqlIntoAQB).
    // AQB.Web.beforeSend is AQB's own hook, called for every request it sends; grid edits go through
    // the 800ms-debounced _sendDataToServerDelayed, which is wrapped to note that a send is still coming.
    installAQBRequestTracking() {
        if (this.aqbTracking)
            return;
        const tracking = this.aqbTracking = { inFlight: 0, delayedUntil: 0 };

        const prevBeforeSend = AQB.Web.beforeSend;
        AQB.Web.beforeSend = function (xhr, data) {
            tracking.inFlight++;
            xhr.addEventListener("loadend", () => tracking.inFlight--);
            if (typeof prevBeforeSend === "function")
                prevBeforeSend(xhr, data);
        };

        const core = AQB.Web.Core;
        const sendDelayed = core._sendDataToServerDelayed;
        if (typeof sendDelayed === "function") {
            core._sendDataToServerDelayed = function () {
                tracking.delayedUntil = Date.now() + 1000;
                return sendDelayed.apply(this, arguments);
            };
        }
    }

    // Load a query's SQL into AQB once AQB has no other request pending.
    // AQB sends requests without queueing them and applies every response in arrival order, and the server
    // loads/saves the query-builder state per request without locking. If a request for the previously opened
    // query (e.g. a debounced grid edit) is still pending when the new SQL is sent, it can finish last and put
    // the previous query back on screen - and into the server state that Save reads the SQL from.
    loadSqlIntoAQB(sqlExpr, suppressDirty) {
        const self = this;
        const tracking = self.aqbTracking;
        const token = self.aqbLoadToken = (self.aqbLoadToken || 0) + 1;
        const started = Date.now();

        const send = function () {
            if (token !== self.aqbLoadToken)                        // another query was opened in the meantime
                return;
            const busy = tracking && (tracking.inFlight > 0 || Date.now() < tracking.delayedUntil);
            if (busy && Date.now() - started < 10000) {             // ~10s safety cap
                setTimeout(send, 50);
                return;
            }
            AQB.Web.Core.ExchangeObject.flush();                    // drop any change still queued for the previous query
            if (suppressDirty)
                self.searchResultSelectedChanged = true;            // a late response for the previous query may have consumed the flag
            AQB.Web.Core.updateSQL(sqlExpr);
            AQB.Web.Core.sendDataToServer();
        };
        send();
    }

    initializeDetailContentHeader(detailContentHeader) {
        const havingCustomWidget = detailContentHeader.havingCustomWidget;
        if (havingCustomWidget) {
            document.getElementById("createModifySpan").innerHTML = ModifyWidgetLabel;
        } else {
            document.getElementById("createModifySpan").innerHTML = CreateWidgetLabel;
        }

        this.detailContainer = $(`#${detailContentHeader.detailHeaderContainer}`); 
        this.detailContentContainer = $(this.detailContainer).find(".cpiDataContainer");

        const detailHeaderContainer = this.detailContainer;                                                     // dataQueryDetail

        const self = this;
        const mainControlButtons = $(detailHeaderContainer).find(".cpiButtonsDetail");
        const saveCancelButtons = $(detailHeaderContainer).find("#editActionButtons");                          // actionsButtons
        const aqbContainer = $(this.aqbContainerId);
        // per-tab AQB instance name; sent with every server call so the correct query builder is used
        // when multiple query tabs/windows are open at once
        const aqbInstance = aqbContainer.data("aqb-instance");
        const isAQBReadOnly = detailContentHeader.isAQBReadOnly;

        let addMode = detailContentHeader.addMode;
        let id = detailContentHeader.id;
        const suppressAQBDirty = self.searchResultSelectedChanged;     // set by gridDisplayDetail when a query is picked from the search grid

        self.installAQBRequestTracking();

        let entryForm = detailHeaderContainer.find("form")[0];

        // reset dirty flags
        this.isParentDirty = false;
        let isAQBDirty = false;                             // flag for AQB SQL changes
        cpiBreadCrumbs.markLastNode({ dirty: false });

        // set up AQB area
        const clearQueryResultGrid = function() {
            const gridId = aqbContainer.data("result-grid");
            var grid = $(`#${gridId}`); //.data("kendoGrid");
            if (grid) {
                grid.empty();
            }
        }

        // skip AQB interaction on the blank landing page (id === -1): there is no query to load,
        // the AQB area is hidden, and AQB may not have finished its async init yet on page refresh
        // (calling sendDataToServer too early throws "Cannot set properties of undefined (_pingCount)").
        if (id !== -1) {
            aqbContainer.find(".dq-query-tab").tab('show');             // set focus on tab with AQB, else it will not refresh AQB
            const sqlExpr = $('#SQLExpr').val();                    // set AQB expr; this will trigger AQB SqlChanged, which will trigger SQLExpr change event below
            self.loadSqlIntoAQB(sqlExpr, suppressAQBDirty);
        }

        if (isAQBReadOnly) {
            $("#divAQB").addClass("masked-area");
            $("#aqbRemarks").attr("readonly", true);
        }
        else {
            $("#divAQB").removeClass("masked-area");
            $("#aqbRemarks").attr("readonly", false);
        }
        clearQueryResultGrid();


        // note: breadcrumbs moved up to avoid detail content refresh issues
        //pageHelper.moveBreadcrumbs(`#${detailContentHeader.detailHeaderContainer}`);
        self.moveSideBar(false);

       //workaround for buttons to be visible when search screen is hidden
        $("#dataQuerySearch").find(".close").on("click", () => {
            $("#dataQuerySearch").find(".cpiButtonsDetail").prepend("&nbsp;");
            $("#dataQuerySearch").find("#editActionButtons").prepend("&nbsp;");
        });

        // skip all of the form-dependent setup below on the blank landing page (id === -1): the
        // view renders no <form> there at all, so `entryForm` would be an empty jQuery object and
        // entryForm.data("validator") would be undefined, throwing on the next line.
        if (id === -1) {
            return;
        }

        // attach jquery validator
        $.validator.unobtrusive.parse(entryForm);
        entryForm = $(entryForm);
        entryForm.data("validator").settings.ignore = "";               // include hidden fields (kendo controls)
        pageHelper.addMaxLength(entryForm);                             // auto add maxlength to entry fields

        // main buttons
        if (detailHeaderContainer.length > 0) {
            self.manageDetailPageButtons({ detailContainer: detailHeaderContainer, id: id });
        }

        //download power bi connector button
        detailHeaderContainer.find("#downloadPowerBIConnectorButton").on("click", (e) => {
            window.fileUtility.getFileStream($(e.currentTarget).data("url"));
        });

        // record stamps - in separate section of page
        const recordStampsUrl = entryForm.data("recordstamp-url");
        self.refreshRecordStamps(recordStampsUrl, id, addMode);

        // show save/cancel buttons, hide other buttons
        const setToSaveMode = function () {
            saveCancelButtons.removeClass("d-none");
            mainControlButtons.hide();            
        };

        const setToViewMode = function () {
            saveCancelButtons.addClass("d-none");
            mainControlButtons.show();
            cpiBreadCrumbs.markLastNode({ dirty: false });
            //refreshNodeDirtyFlag();                           // n/a - refreshes grid
        };

        const markDirty = function () {
            self.isParentDirty = true;
            cpiBreadCrumbs.markLastNode({ dirty: true });
            detailHeaderContainer.addClass("dirty");
            setToSaveMode();
        };

        // attach markDirty to SQLExpr change
        $('#SQLExpr').change(function () {
            console.log("change trigger");

            if (isAQBReadOnly)
                return;
            markDirty();
        });

        // set aqbRemarks with hidden remarks; attach markDirty 
        self.setRemarks("#Remarks", "#aqbRemarks");
        $("#aqbRemarks").on("input", function () {
            markDirty();
        });

        // attach markDirty to input fields
        $(document).on("input", ".cpiMainEntry input, .cpiMainEntry textarea",function () {
            markDirty();
        });

        const submitForm = function () {
            cpiLoadingSpinner.show();

            // update hidden remarks inside the form; 
            self.setRemarks("#aqbRemarks", "#Remarks");             // this is the remarks that will post to the server
            if (!addMode)
                self.fillRecordStamp(entryForm);                    // update hidden stamps field inside the form

            const json = pageHelper.formDataToJson(entryForm);

            // include the per-tab AQB instance so Save pulls SQL from the query builder on THIS tab
            let saveAction = entryForm.attr("action");
            if (aqbInstance)
                saveAction += (saveAction.indexOf("?") === -1 ? "?" : "&") + "aqbInstance=" + encodeURIComponent(aqbInstance);

            pageHelper.postJson(saveAction, json)
                .done(function (result) {
                    cpiLoadingSpinner.hide();
                    pageHelper.showSuccess(entryForm.data("save-message"));

                    self.isParentDirty = false;
                    self.searchResultSelectedChanged = false;

                    setToViewMode();
                    detailHeaderContainer.removeClass("dirty");

                    // refresh search grid client side (w/o resetting everything)
                    self.selectSearchResultRow = false;
                    if (addMode) {
                        const data = { QueryId: result.QueryId, QueryName: result.QueryName };
                        self.insertSearchGridRow(self.searchResultGridId, data);
                        addMode = false;
                    } else {
                        const grid = $(self.searchResultGridId).data("kendoGrid");
                        const select = grid.select();
                        const data = grid.dataItem(select);
                        data.set("QueryName", result.QueryName);
                        $(self.searchResultGridId).find("span.k-dirty").remove();
                        $(self.lastGridSelection).addClass("k-state-selected");
                    }

                    // refresh timestamps
                    id = result.QueryId;
                    const recordStampsUrl = entryForm.data("recordstamp-url");
                    self.refreshRecordStamps(recordStampsUrl, id, addMode);

                    pageHelper.resetComboBoxes(self.searchForm);        // refresh search buttons to reflect saved data

                })
                .fail(function (e) {
                    cpiLoadingSpinner.hide();
                    pageHelper.showErrors(e);

                    // do NOT refresh the search grid on failure: the save didn't change the DB,
                    // and the grid reload would navigate to the blank landing page and clear the
                    // error message (via searchResultGridRequestEnd -> cpiStatusMessage.hide()).
                    // Keep the user on the form with the error so they can fix it and retry.
                    //self.refreshSearchGrid();
                });
        };

        entryForm.on("submit", function (e) {
            e.preventDefault();
            //client side validation (using jquery validation)
            if (entryForm.valid()) {
                submitForm();
            }
            else {
                cpiLoadingSpinner.hide();
                entryForm.wasValidated();
            }
        });
    }

    initializeDetailContentMain(detailContentMain) {
        this.dqMainContainerId = detailContentMain.dqMainContainerId;
        this.aqbContainerId = detailContentMain.aqbContainerId;

        const aqbContainer = $(`${this.aqbContainerId}`);                      //dataQueryDetail
        // per-tab AQB instance name; sent with every server call so the correct query builder is used
        // when multiple query tabs/windows are open at once
        const aqbInstance = aqbContainer.data("aqb-instance");
        const aqbResultGridId = detailContentMain.aqbResultGridId;
        const self = this;


        const runQuery = function (url) {
            // 1) get the grid model (url + 'Init'); 2) pass it on to dynamicGrid.createGrid
            cpiLoadingSpinner.show();
            $.ajax({
                url: url + 'Init',
                data: { aqbInstance: aqbInstance },
                success: (gridModel) => {
                    const modelJson = JSON.parse(gridModel);
                    dynamicGrid.createGrid(aqbResultGridId, modelJson, url, { aqbInstance: aqbInstance });
                    cpiLoadingSpinner.hide();
                },
                error: function (e) {
                    if (e.responseJSON !== undefined)
                        pageHelper.showGridErrors(e.responseJSON);
                    else
                        pageHelper.showErrors(e.responseText);
                    cpiLoadingSpinner.hide();
                }
            });

        }

        const isEmptyQuery = function () {
            var qb = AQB.Web.QueryBuilder;
            if (qb.EditorComponent.getSql() === "") {
                const msg = aqbContainer.data("empty-sql");
                cpiAlert.warning(msg, function () {
                    aqbContainer.find(".dq-query-tab").tab('show');
                });
                return true;
            }
            return false;
        }


        const openExportWidgetEntry = function (url, data, closeOnSave) {
            const self = this;

            $.ajax({
                url: url,
                data: data,
                success: function (result) {
                    const popupContainer = $(".cpiContainerPopup").last();
                    popupContainer.html(result);
                    const dialogContainer = $("#dqExportToWidgetDialog");

                    let entryForm = dialogContainer.find("form")[0];
                    dialogContainer.modal("show");
                    entryForm = $(entryForm);
                    entryForm.cpiPopupEntryForm(
                        {
                            dialogContainer: dialogContainer,
                            closeOnSubmit: closeOnSave,
                            beforeSubmit: function () {
                                //const parentStamp = self.getParentTStamp();
                                //dialogContainer.find("#ParentTStamp").val(parentStamp);
                            },
                            afterSubmit: function () {
                                dialogContainer.modal("hide");
                            }
                        }
                    );
                },
                //error: function (error) {
                //    pageHelper.showErrors(error.responseText);
                //}
            });
        }

        const exportData = function (urlData) {
            if (isEmptyQuery()) {
                return;
            }

            const url = aqbContainer.data(urlData);
            const queryName = $('input[name$="QueryName"]')[1].value;
            const aqbResultGrid = $(aqbResultGridId).data("kendoGrid");


            let data = { queryName: queryName, aqbInstance: aqbInstance };
            if (aqbResultGrid !== undefined) {
                const sort = aqbResultGrid.dataSource.sort();
                if (sort !== undefined)
                    $.extend(data, { sortField: sort[0].field, sortDir: sort[0].dir })
            }

            window.fileUtility.getFileStream(url, data);
        }

        // Run query button
        aqbContainer.find(".run-query").on("click", function () {
            if (!isEmptyQuery()) {
                const url = aqbContainer.data("run-url");
                runQuery(url);
            }
        });

        // Export to Excel
        aqbContainer.find(".export-excel").on("click", function () {
            exportData("export-excel-url");
        });

        // Export to Excel
        aqbContainer.find(".export-word").on("click", function () {
            exportData("export-word-url");
        });

        // Export to XML
        aqbContainer.find(".export-xml").on("click", function () {
            exportData("export-xml-url");
        });

        // Export to XML
        aqbContainer.find(".export-json").on("click", function () {
            exportData("export-json-url");
        });

        aqbContainer.find(".export-rdl").on("click", function () {
            exportData("export-rdl-url");
        });

        aqbContainer.find(".export-widget").on("click", function () 
            {
            const queryId = document.getElementById("QueryId").value;
            const url = aqbContainer.data("export-widget-url");
                const data = {
                    queryId: queryId,
                };
            openExportWidgetEntry(url, data, true);
        });

        // open query help form
        aqbContainer.find(".query-help").on("click", function () {
            const url = aqbContainer.data("help-url");
            self.showHelp(url);
        });

    }

    showHelp = (url) => {
        $.get(url)
            .done((result) => {
                //clear all existing hidden popups to avoid kendo id issue
                $(".cpiContainerPopup").empty();

                const popupContainer = $(".cpiContainerPopup").last();
                popupContainer.html(result);
            })
            .fail((e) => {
                pageHelper.showErrors(e.responseText);
            });
    }
    setRemarks(fromRemarksId, toRemarksId) {
        const fromRemarks = $(fromRemarksId).val();
        $(toRemarksId).val(fromRemarks);

        const tab = $("#dataQueryRemarksTab");
        if (fromRemarks === "")
            tab.removeClass("has-remarks");
        else
            tab.addClass("has-remarks");

    }; 

    refreshRecordStamps(url, id, addMode) {
        const stampContainer = $(this.dqMainContainerId);
        if (addMode) {
            stampContainer.find(".content-stamp").hide();
        } else if (id > 0) {
            const recordStampsUrl = url.replace("recid", id);
            const activePage = { recordStampsUrl: recordStampsUrl, infoContainer: stampContainer };
            pageHelper.updateRecordStamps(activePage);
            stampContainer.find(".content-stamp").show();
        }
    }

    fillRecordStamp(entryForm) {
        // record stamp is shown at the footer separate from the form body; 
        // update the empty tStamp inside the form before posting form to server
        const tStampForm = entryForm.find("#tStamp");
        tStampForm.val(dataQuery.getRecordStamp());
    }

 }


